import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, map, Observable, tap } from 'rxjs';
import { Permission } from '../models/models.lib';
import { SettingsService } from '../settings/settings.service';
import { ApiService } from '../api/api.service';
import { Settings } from '../common/obj.lib';

export abstract class EnvironerPermissionService extends BehaviorSubject<Array<any>>{
  public loading: boolean = false;
  private settings: Settings = this.settingsService.getSettings();

  constructor(
    private http: HttpClient,
    private settingsService: SettingsService
  ) {
    super([]);
  }

  public query(): void {
    this.fetch().subscribe((x) => {
      // console.log('query: x: ', x);
      return super.next(x);
    });
  }

  protected fetch(): Observable<Permission[]> {
    this.loading = true;
    this.settings = this.settingsService.getSettings();

    return this.http.get(encodeURI(`${this.settings.apiUrl}/permissions`))
      .pipe(
        map((response: any, i) => <Permission[]>response),
        map(r => r.map(x => Permission.create(x))),
        // tap(nr => {
        //   console.log('nr: ', nr);
        // }),
        tap(() => (this.loading = false))
      )
  }
}

@Injectable({
  providedIn: 'root'
})
export class PermissionService  extends EnvironerPermissionService {


  constructor(
    http: HttpClient,
    private settingService: SettingsService,
    private apiService: ApiService
  ) {
    super(http, settingService);
  }

  get() {
    return this.apiService.getHttpCall('permissions', 'get');
  }

  getById(id: number): Promise<any> {
    return this.apiService.getHttpCallAsPromise(`permissions/${id}`, 'getById');
  }

  add(p: any): Promise<any> {
    return this.apiService.postHttpCallAsPromise('permissions', p, 'add');
  }

  update(p: any): Promise<any> {
    return this.apiService.putHttpCallAsPromise(`permissions/${p.id}`, p, 'update');
  }

  destroy(id: number): Promise<any> {
    return this.apiService.deleteHttpCallAsPromise(`permissions/${id}`, 'destroy');
  }
}
